import React, { Component } from 'react';
import { muiWithStyles, MuiGrid, MuiButton, MuiAddCircle, MuiTypography, MuiFab } from '../../../ui/MaterialUIComponents';
import AddSubjectsComponent from './AddSubjectsComponent';
import theme from '../../../../assests/theme'
import spinner from "../../../ui/icons/spinner.gif"
import PageHeaderComponent from '../../../ui/PageHeaderComponent'
import '../../../ui/scrollbarForLog.css'
import lodashUtil from 'lodash';
export class Subjects extends Component {
  constructor(props) {
    super(props)
    this.state = {
      confimationDialogSubjects: false,
      toggleChange: false
    }
  }
  renderAddRow = () => {
    let subjectList = this.props.subjectList
    this.updateData()
    let color = theme.colorCatalogue[this.props.subjectList.length % theme.colorCatalogue.length]
    let activeSubject = {
      color: color,
      id: subjectList.length + 1,
      name: "",
      description: "",
      gradeDetails: {
        allGrades: true,
        gradeLevels: [],
        grades: []
      }
    }
    subjectList.push(activeSubject)
    this.setState({
      subjectList: subjectList,
      activeSubject: activeSubject,
      confimationDialogSubjects: true
    })
  }
  getSortedList() {
    return lodashUtil.orderBy(this.props.subjectList, ['name'], ['asc'])
  }

  updateData = () => {
    if (!this.props.confimationDialogSubjects.isChanged) {
      this.props.confimationDialogSubjects.isChanged = true
    }
    this.setState({
      toggleChange: !this.state.toggleChange
    })
  }
  render() {
    if (this.props.subjects !== undefined || this.props.subjectMasterData.subjects == undefined || this.props.updateSchoolinformationInProgress === true) {
      return <MuiGrid container xs={12} alignItems="stretch" justify='center' alignContent='center' direction='column' >
        <img src={spinner} alt="none" style={theme.spinnerImgStyle} /></MuiGrid>
    }
    const { i18n } = this.props
    return (

      <MuiGrid container xs={12} >
        <PageHeaderComponent {...this.props} title={i18n.subjects.title} subTitle={i18n.subjects.tabDescription} />

        < MuiGrid container xs={12} >
          < MuiGrid container xs={12} style={theme.tableHeaderStyle}>
            {/* < MuiGrid container xs={12} direction='row' style={theme.gridHeaderStyle}> */}
            < MuiGrid item xs={4}>
              <MuiTypography style={theme.tableHeaderTextStyle}>   {i18n.subjects.subjectName}
              </MuiTypography>
            </ MuiGrid>
            < MuiGrid item xs={2}>  <MuiTypography style={theme.tableHeaderTextStyle}>   {i18n.subjects.subjectCode}
            </MuiTypography></ MuiGrid>
            {/* < MuiGrid item xs={2}>
              <MuiTypography style={theme.tableHeaderTextStyle}>   {i18n.subjects.briefDescription} {i18n.subjects.optional}
              </MuiTypography>
            </ MuiGrid> */}
            < MuiGrid item xs>  <MuiTypography style={theme.tableHeaderTextStyle}>    {i18n.subjects.subjectGradeDetail}
            </MuiTypography></ MuiGrid>
          </ MuiGrid>
          <MuiGrid container id='scrollStyle' xs={12} style={{ maxHeight: '62vh', overflowY: 'auto' }}>
            {this.props.subjectList.map((subject, index) =>
              < MuiGrid item xs={12} id='grid'>
                <AddSubjectsComponent
                  {...this.state}
                  {...this.props}
                  subject={subject}
                  index={index}
                  updateData={this.updateData}
                />
              </ MuiGrid>
            )}
          </MuiGrid>
          <MuiGrid container xs={12} onClick={() => this.renderAddRow()} style={theme.gridActionContainerStyleForStickyButton} justify="center" alignItems="center">
            <MuiGrid item >

              <MuiAddCircle style={{ color: theme.palette.orange }} fontSize='large' />
            </MuiGrid>
            <MuiGrid item >
              <MuiTypography style={theme.addMoreStyle}>
                {i18n.subjects.addMoreSubjects}
              </MuiTypography>
            </MuiGrid>
          </MuiGrid>
          {/* </ MuiGrid> */}
        </ MuiGrid>
        <MuiGrid container xs={12} style={{ height: '2vh' }}></MuiGrid>
        <MuiGrid container xs={12} justify="flex-end" >
          <MuiButton
            disabled={!this.props.confimationDialogSubjects.isChanged}
            style={!this.props.confimationDialogSubjects.isChanged ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle}
            onClick={() => { this.props.onClickOfSave() }}>
            {i18n.commonTexts.save}
          </MuiButton>
        </MuiGrid>
      </MuiGrid>
    )
  }
}
export default Subjects

